<template>
  <v-container fluid class="container-page">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex text-title-container"
      >
        <div class="text-title text-primary">Queues</div>
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
          <div class="text-label m-r-10">
            {{ showActive ? 'Show only active queues' : 'Show all queues' }}
          </div>
          <v-switch
            v-model="showActive"
            inset
            dense
            x-small
            hide-details
          ></v-switch>
        </div>
        <v-btn
          id="new-user"
          class="m-auto"
          color="btn-primary"
          @click="dialog = true"
          >New</v-btn
        >
      </v-col>
    </v-row>

    <div>
      <v-data-table
        :loading="loading"
        loading-text="Loading..."
        :headers="headers"
        :items="queues"
        :sort-by.sync="search.sortBy"
        :sort-desc.sync="search.sortDesc"
        :items-per-page="9999"
        hide-default-footer
        fixed-header
        must-sort
        class="elevation-1"
      >
        <template v-slot:item="props">
          <tr
            :id="`queue${queues.indexOf(props.item)}`"
            class="cursor-pointer"
            @click="editItem(props.item)"
          >
            <td class="text-center">
              <v-icon small>{{
                props.item.type === 'voice' ? 'fa-phone' : 'fa-comment-dots'
              }}</v-icon>
            </td>
            <td>{{ props.item.name }}</td>
            <td class="text-center">
              {{ props.item.type === 'voice' ? 'Voice' : 'Chat' }}
            </td>
            <td>
              {{ props.item.status ? 'Active' : 'Inactive' }}
            </td>
            <td class="text-right">
              <v-menu :absolute="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="props.item.editable"
                    :id="`action${queues.indexOf(props.item)}`"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="deleteItem(props.item)"
                  >
                    fa-trash
                  </v-icon>
                </template>
              </v-menu>
            </td>
          </tr>
        </template>
        <!-- <template v-slot:[`item.last_login`]="{ item }">
        {{ item.last_login | datetimeFormat }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        {{ item.status ? 'Open' : 'Closed' }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon v-if="item.editable" small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="item.editable"
          small
          class="mr-2"
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template> -->
        <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="getUser">Reset</v-btn>
        </template> -->
      </v-data-table>
    </div>

    <dialog-manage
      v-if="dialog"
      :viewType="viewType"
      :rules="rules"
      :dialog="dialog"
      :editedIndex="editedIndex"
      :editedItem="editedItem"
      :errorMessage="errorMessage"
      @close="close"
      @save="save"
    />

    <dialog-confirm
      v-if="dialogConfirm.open"
      :dialogConfirm="dialogConfirm"
      @dialogConfirmClick="dialogConfirmClick"
    />

    <snackbar v-if="snackbar.open" :snackbar="snackbar" />
  </v-container>
</template>
<script>
import _ from 'lodash'
import apiQueue from '@/apis/queue'
import DialogManage from './components/dialog_manage'
import Snackbar from './components/snackbar'
import DialogConfirm from './components/dialog_confirm'
export default {
  name: 'Queues',
  props: {
    rulesCharcacters50: Object
  },
  components: {
    DialogManage,
    Snackbar,
    DialogConfirm
  },
  data() {
    return {
      viewType: process.env.VUE_APP_TYPE,
      loading: false,
      search: {
        sortBy: [],
        sortDesc: []
      },
      headers: [
        {
          text: '',
          sortable: false,
          align: 'right',
          value: 'direction',
          width: '3%'
        },
        {
          text: 'Queue',
          align: 'start',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Type',
          align: 'center',
          sortable: true,
          value: 'type'
        },
        { text: 'Status', value: 'status', sortable: true },
        { text: '', value: 'actions', sortable: false, align: 'right' }
      ],
      queues: [],
      allQueues: [],
      dialog: false,
      editedIndex: -1,
      editedItem: {
        _id: '',
        name: '',
        type: '',
        status: true,
        editable: ''
      },
      defaultItem: {},
      errorMessage: '',
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      },
      dialogConfirm: {
        open: false,
        _id: '',
        name: ''
      },
      showActive: true
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    showActive: {
      handler() {
        this.filterActive()
      }
    }
  },
  computed: {
    rules() {
      return {
        rulesCharcacters50: this.rulesCharcacters50
      }
    }
  },
  created() {
    document.title = this.$t('page-title.queues', {
      productName: this.$options.filters.getVariable('product_name')
    })

    this.defaultItem = _.cloneDeep(this.editedItem)

    this.initial()
  },
  methods: {
    viewVoice() {
      return this.viewType === 'voice'
    },
    viewChat() {
      return this.viewType === 'chat'
    },
    viewAll() {
      return this.viewType === 'all'
    },
    async initial() {
      await this.getQueue()
    },
    async getQueue() {
      try {
        this.loading = true
        this.queues = []
        this.allQueues = []
        const getQueue = await apiQueue.getQueue()
        const { data } = getQueue
        for (let i = 0; i < data.length; i++) {
          if (
            (data[i].type === 'voice' &&
              (this.viewAll() || this.viewVoice())) ||
            (data[i].type === 'chat' && (this.viewAll() || this.viewChat()))
          ) {
            const obj = {}
            obj._id = data[i]._id ? data[i]._id : ''
            obj.name = data[i].name
            obj.type = data[i].type
            obj.status = data[i].status
            obj.editable = data[i].editable
            this.allQueues.push(obj)
          }
        }

        this.filterActive()

        setTimeout(() => {
          this.loading = false
        }, 500)
      } catch (error) {}
    },
    filterActive() {
      if (this.showActive) {
        this.queues = _.filter(this.allQueues, { status: true })
      } else {
        this.queues = [...this.allQueues]
      }
    },
    editItem(item) {
      if (!item.editable) return

      this.editedIndex = this.queues.indexOf(item)
      this.editedItem = _.cloneDeep(item)

      this.errorMessage = ''
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = _.cloneDeep(this.defaultItem)
        this.editedIndex = -1
      })
      this.errorMessage = ''
    },
    async save() {
      try {
        if (!this.editedItem.name) {
          this.errorMessage = 'Queue name is required'
          return false
        } else if (
          this.editedItem.name.length < 1 ||
          this.editedItem.name.length > 50
        ) {
          this.errorMessage = 'Queue name must be 1-50 characters'
          return false
        }
        const obj = {
          name: this.editedItem.name.trim(),
          type: this.editedItem.type,
          status: this.editedItem.status
        }
        if (this.editedIndex > -1) {
          const _id = this.editedItem._id

          await apiQueue.updateQueue(_id, obj)

          this.snackbar.colorSnackbar = 'success'
          this.snackbar.textSnackbar = 'Changes saved'
          this.snackbar.open = true

          this.getQueue()
          this.close()
        } else {
          if (!this.editedItem.name) {
            this.errorMessage = 'Queue name is required'
            return false
          } else if (
            this.editedItem.name.length < 1 ||
            this.editedItem.name.length > 50
          ) {
            this.errorMessage = 'Queue name must be 1-50 characters'
            return false
          }

          await apiQueue.createQueue(obj)

          this.snackbar.colorSnackbar = 'success'
          this.snackbar.textSnackbar = `${this.editedItem.name} created`
          this.snackbar.open = true

          this.getQueue()
          this.close()
        }
      } catch (error) {
        this.errorMessage = error.message
      }
    },
    deleteItem(item) {
      this.dialogConfirm.open = true
      this.dialogConfirm._id = item._id
      this.dialogConfirm.name = item.name
    },
    async dialogConfirmClick() {
      const deleteQueue = await apiQueue.deleteQueue(this.dialogConfirm._id)
      if (deleteQueue.code === 0) {
        this.getQueue()
        this.close()
        this.snackbar.colorSnackbar = 'error'
        this.snackbar.textSnackbar = `${this.dialogConfirm.name} deleted`
        this.snackbar.open = true
        this.setDefaultDialogConfirm()
      } else {
        this.snackbar.colorSnackbar = 'error'
        this.snackbar.textSnackbar = deleteQueue.message
        this.snackbar.open = true
      }
    },
    setDefaultDialogConfirm() {
      this.dialogConfirm.open = false
      this.dialogConfirm._id = ''
      this.dialogConfirm.name = ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  height: calc(100vh - 129px);
}
</style>
